import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./suggestionOption.html";
// Splits on the `{`/`}` highlight markers produced by wrapKeyword(), keeping the
// delimiters in the result so we can track whether we're inside a highlighted run.
const HIGHLIGHT_DELIMITER_PATTERN = /([{}])/;
// Matches the bracket characters the legacy string-based transform stripped out.
const BRACKET_CHARS_PATTERN = /[)([\]]/g;
class SuggestionOption extends LightningElement {
  constructor(...args) {
    super(...args);
    this.suggestion = void 0;
  }
  renderedCallback() {
    const suggestionText = this.template.querySelector('.suggestion-text');
    if (suggestionText) {
      // Never assign attacker-influenced text via innerHTML. Instead, build the DOM
      // nodes programmatically (text nodes + <mark> elements) so the suggestion text
      // is always treated as data, never parsed as markup.
      suggestionText.replaceChildren(...this.buildSuggestionNodes());
    }
  }

  /**
   * Builds a list of DOM nodes representing the suggestion text, wrapping any
   * `{...}`-delimited segments in <mark> elements. All text content is set via
   * textContent/createTextNode, so no HTML parsing of untrusted text ever occurs.
   */
  buildSuggestionNodes() {
    const highlighted = this.suggestion?.highlighted;
    if (!highlighted) {
      // No highlight markers to parse — emit the raw keyword as a single text node
      // rather than running it through marker/bracket parsing meant for `highlighted`
      // text. This preserves punctuation (e.g. parentheses, brackets) in the user's
      // original input, matching what actually gets submitted when this is clicked.
      return [document.createTextNode(this.suggestion.suggestedKeyword)];
    }
    const nodes = [];
    let insideHighlight = false;
    for (const segment of highlighted.split(HIGHLIGHT_DELIMITER_PATTERN)) {
      if (segment === '{') {
        insideHighlight = true;
        continue;
      }
      if (segment === '}') {
        insideHighlight = false;
        continue;
      }
      const text = segment.replace(BRACKET_CHARS_PATTERN, '');
      if (!text) {
        continue;
      }
      if (insideHighlight) {
        const mark = document.createElement('mark');
        mark.textContent = text;
        nodes.push(mark);
      } else {
        nodes.push(document.createTextNode(text));
      }
    }
    return nodes;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SuggestionOption, {
  publicProps: {
    suggestion: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(SuggestionOption, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;